"use client";
import Image from "next/image";

import { WithMobile } from "@/lib/isMobile";
import { usePathname } from "next/navigation";
import { productInfo, productKeyMap } from "@/config/productInfo";

interface Props {
  deviceType?: {
    isMobile: boolean;
    isPad: boolean;
  };
}

function HeaderEle({ deviceType }: Props) {
  const path = usePathname(),
    curPath = path.split("/").slice(-1)[0] as keyof typeof productKeyMap;

  const infoList = productInfo[productKeyMap[curPath]];
  const featureList = infoList?.feature || [];
  const headTitle = infoList?.headTitle || {};
  return (
    <section>
      <div className="w-full relative">
        {deviceType!.isMobile ? (
          <Image
            className="w-full h-full"
            width="750"
            height="600"
            quality={100}
            src={headTitle.mobileImg}
            alt="banner1"
            priority
          />
        ) : (
          <>
            <div
              className="container absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] text-white text-start
              space-y-6"
            >
              <h2 className="text-[2.125rem] font-bold">{headTitle.title}</h2>
              <div>
                <h3 className="text-2xl">{headTitle.desc1}</h3>
                <h3 className="text-2xl">{headTitle.desc2}</h3>
              </div>
            </div>
            <Image
              className="w-full h-[360px] object-cover object-center"
              width="2560"
              height="360"
              quality={100}
              src={headTitle.img}
              alt="banner2"
              priority
            />
          </>
        )}
        <div
          className="container space-y-6  absolute  bottom-0  left-[50%]
          translate-x-[-50%] translate-y-[60%]"
        >
          <div
            className="w-full flex flex-center flex-nowrap space-x-1 md:space-x-6 px-6 md:px-0
          items-stretch"
          >
            {featureList.map((item, idx) => (
              <div
                className="flex-center rounded-md px-3 md:px-7 py-3 md:py-5 md:space-x-4 flex-1
                  border border-[#F2F2F2] bg-[rgba(255,255,255,0.96)]
                  shadow-[4px_4px_12px_0_rgba(0,37,86,0.1)]
                  flex-col md:flex-row
                  "
                key={idx}
              >
                <Image
                  className="w-12 md:w-[96px] h-12 md:h-[96px]"
                  width="192"
                  height="192"
                  quality={100}
                  src={item.icon}
                  alt="feature"
                />
                <div className="mt-2 md:mt-0 text-[#333333] flex flex-1 flex-col space-y-1 md:space-y-2 items-center md:items-start">
                  <p className="text-xs md:text-lg font-bold md:font-medium">
                    {item.title}
                  </p>
                  <p className="text-xs md:text-sm text-[#666666]">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WithMobile(HeaderEle);
